module.exports = __webpack_public_path__ + "img/diwen.299c4b18.png";